import classNames from 'classnames';
import DecoderText from 'components/DecoderText';
import Heading from 'components/Heading';
import { ProjectTextRow } from 'components/ProjectLayout';
import Section from 'components/Section';
import SegmentedControl, { SegmentedControlOption } from 'components/SegmentedControl';
import { Fragment, useState } from 'react';
import { Transition } from 'react-transition-group';
import { reflow } from 'utils/transition';
import './Details.css';
import Timeline from './Timeline';

const ProfileText = ({ status, titleId }) => (
  <Fragment>
    <Heading
      className={classNames('profile__title', `profile__title--${status}`)}
      level={3}
      id={titleId}
    >
      <DecoderText text="Timeline" start={status !== 'exited'} delay={500} />
    </Heading>
  </Fragment>
);

const Profile = ({ id, visible, sectionRef }) => {
  const titleId = `${id}-title`;

  const [selectedTimeline, setSelectedTimeline] = useState(0);
  const handleTimelineChange = index => {
    setSelectedTimeline(index);
  };


  return (
    <Section
      className="profile"
      as="section"
      id={id}
      ref={sectionRef}
      aria-labelledby={titleId}
      tabIndex={-1}
    >
      <Transition in={visible} timeout={0} onEnter={reflow}>
        {status => (
          <div className="details__content">

            <ProfileText status={status} titleId={titleId} />
            <ProjectTextRow  center  width="l">
              <SegmentedControl
                currentIndex={selectedTimeline}
                onChange={handleTimelineChange}
              >
                <SegmentedControlOption>Experience</SegmentedControlOption>
                <SegmentedControlOption>Education</SegmentedControlOption>
              </SegmentedControl>
            </ProjectTextRow>

            <Timeline selectedTimeline={selectedTimeline} />


          </div>
        )}
      </Transition>
    </Section>
  );
};

export default Profile;
